import { h, Component } from 'preact';
import Beans3 from '@/beans';
import { Utils } from '@/base/helpers';
import { ActionModalHeader, ActionModalBody } from '@/liana/views/components';

export default class BaseSocialModal extends Component {
  constructor(props, platform) {
    super(props);
    const usernameKey = `${platform.toLowerCase()}_username`;

    this.platform = platform;
    this.usernameKey = usernameKey;

    this.state = {
      social: {
        beans_member_id: props.account.id,
        [usernameKey]: '',
      },
      message: {
        text: '',
        color: Utils.BeansStatusColor.default.color,
      },
      actionRule: props.actionRule,
      loading: false,
      actionStatus: 'auth_required',
      verificationStatus: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleUsernameSave = this.handleUsernameSave.bind(this);
    this.handleUsernameEdit = this.handleUsernameEdit.bind(this);
    this.handleVerificationStatus = this.handleVerificationStatus.bind(this);
  }

  componentDidMount() {
    const platform = this.platform.toLowerCase();
    Beans3.get({ path: `${platform}/shopper/${this.props.account.id}/`, namespace: 'trellis' })
      .then((res) => {
        this.setState({ social: res, actionStatus: 'action_required' });
      })
      .catch(() => {
        this.setState({ actionStatus: 'auth_required', message: {} });
      });
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error in BaseSocialModal:', error, errorInfo);
    this.setState({
      message: {
        text: 'An unexpected error occurred',
        color: Utils.BeansStatusColor.error.color,
      },
    });
  }

  handleChange(event) {
    const value = event.target.value;
    this.setState((prevState) => ({
      social: { ...prevState.social, [this.usernameKey]: value },
    }));
  }

  async handleUsernameSave() {
    const username = this.state.social[this.usernameKey];
    if (!username) {
      this.setState({
        message: {
          text: 'Username cannot be empty',
          color: Utils.BeansStatusColor.error.color,
        },
      });
      return;
    }

    this.setState({ loading: true });
    const platform = this.platform.toLowerCase();

    try {
      const { social } = this.state;
      const { account } = this.props;

      const path = social.id ? `${platform}/shopper/${account.id}/` : `${platform}/shopper/`;

      const method = social.id ? 'put' : 'post';
      const data = await Beans3[method]({
        path,
        data: social,
        namespace: 'trellis',
      });

      this.setState(
        {
          social: data,
          message: {},
          loading: false,
          actionStatus: 'action_required',
        },
        () => this.props.onRuleActionVerify(false, this)
      );
    } catch (error) {
      this.setState({
        message: {
          text: Utils.getErrors(error),
          color: Utils.BeansStatusColor.error.color,
        },
        loading: false,
      });
    }
  }

  handleUsernameEdit() {
    this.setState({ actionStatus: 'auth_required', message: {} });
  }

  handleVerificationStatus(status) {
    this.setState({ verificationStatus: status });
  }

  renderSocialModal() {
    const { loading, actionRule, actionStatus, message, verificationStatus, social } = this.state;
    const { pageLink, onClose, onRuleActionVerify } = this.props;

    const actionRuleCopy = {
      ...actionRule,
      action: { ...actionRule.action, link: pageLink },
    };

    return (
      <div id={`liana-modal-${this.platform}`} className="liana-rule-action-modal">
        <ActionModalHeader headerTitle={this.platform} closeTab={onClose} />
        <ActionModalBody
          actionStatus={actionStatus}
          socialUsername={social[this.usernameKey]}
          message={message}
          loading={loading}
          onChange={this.handleChange}
          onUsernameSave={this.handleUsernameSave}
          onUsernameEdit={this.handleUsernameEdit}
          onRuleActionVerify={() => {
            onRuleActionVerify(true, this);
            this.handleVerificationStatus(true);
          }}
          actionRule={actionRuleCopy}
          socialPlatform={this.platform}
          socialPlatformLogoSVG={this.logo}
          onClose={onClose}
          verificationStatus={verificationStatus}
        />
      </div>
    );
  }
}
